import { fail, pass, skip } from "../buildResult";
import { defineTest } from "../defineTest";

export default defineTest("patient_not_deleted", "Deleted Patient", ({ patient }) => {
  if (!patient?.patient_id) return skip("No patient record");

  if (Boolean(patient.is_deleted)) {
    return fail(
      "This is a deleted patient",
      "is_deleted is TRUE for this patient in postgres"
    );
  }

  return pass("Patient is not deleted");
});
